import { ZoomLevel } from '../Header/ZoomLevelMenu';

export type ZoomProps = {
  showAddress: boolean;
  showSignals: boolean;
  signalThreshold: number;
  titleLineClamp: number;
};

interface ZoomLevels<T> {
  [ZoomLevel.COMPACT]: T;
  [ZoomLevel.STANDARD]: T;
  [ZoomLevel.DETAILED]: T;
}

const zoomProps: ZoomLevels<ZoomProps> = {
  [ZoomLevel.COMPACT]: {
    showAddress: false,
    showSignals: false,
    signalThreshold: 3,
    titleLineClamp: 1
  },
  [ZoomLevel.STANDARD]: {
    showAddress: false,
    showSignals: true,
    signalThreshold: 3,
    titleLineClamp: 1
  },
  [ZoomLevel.DETAILED]: {
    showAddress: true,
    showSignals: true,
    signalThreshold: 3,
    titleLineClamp: 1
  }
};

export const getZoomLevelProps = (enabled: boolean, level: ZoomLevel) =>
  zoomProps[enabled ? level : ZoomLevel.STANDARD];
